var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_facebook",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.446,
    height: 54.446,
    viewBox: "0 0 54.446 54.446",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_16",
    "data-name": "Elipse 16",
    cx: 27.223,
    cy: 27.223,
    r: 27.223,
    transform: "translate(0 54.446) rotate(-90)",
    fill: "#048cc6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-facebook-f",
    "data-name": "Icon awesome-facebook-f",
    d: "M15.686,15.82l.781-5.09H11.583v-3.3a2.545,2.545,0,0,1,2.87-2.75h2.22V.344A27.077,27.077,0,0,0,12.732,0C8.709,0,6.08,2.438,6.08,6.851V10.73H1.609v5.09H6.08v12.3h5.5V15.82Z",
    transform: "translate(18.082 13.16)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFacebook);
export default __webpack_public_path__ + "static/media/ico_facebook.81e7d196aff017c18bb1808dfe6f6ae4.svg";
export { ForwardRef as ReactComponent };